<template>
    <lnb class="lnb--topline-border">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </lnb>
</template>

<script>
import Lnb from "@/components/publish/styles/headers/lnb.vue";

export default {
    props: {},
    components: {
        Lnb,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.lnb--topline-border ::v-deep {
    top: calc(var(--header-body-height) - 4px);
    border-top: 4px solid var(--v-primary-base);
    > li {
        > a {
            border: 1px solid var(--border-color);
            border-top: 0;
            &:hover{
                color: var(--v-primary-base);
            }
        }
    }
}
</style>
